// extracted by mini-css-extract-plugin
export default {"navSection":"Navbar_navSection__FFKyJ","modeBTN":"Navbar_modeBTN__-8ePv","scrolled":"Navbar_scrolled__x9OCI"};